import { XML_ConvertDPI } from "./XML_ConvertDPI";
import { XML_GetScale } from "./XML_GetScale";
import { XML_GetDY } from "./XML_GetDY";

export function XML_ScaleAndShiftY(y, drawElement, layer) {
  y = XML_ConvertDPI(y);
  var scale = XML_GetScale(drawElement, layer); //drawElement["scale"];
  if (scale != null) y = y * scale;

  var dy = XML_GetDY(drawElement, layer); // drawElement["dy"];
  if (dy != null) y += dy;

  //	y = RoundTo3(y)
  return y;
}
